import request from './request';
import { getAuth, setAuth, removeAuth, isOpenApi, getApiUrl } from './utils';
import { getRequestedService } from '../utils';

const API_URL = getApiUrl();

export const fetchAndSaveAuthToken = async ({
  liffId,
  userId,
  service = getRequestedService(),
}) => {
  console.log('debug: fetchAndSaveAuthToken - ', { liffId, userId });
  console.log('debug: isOpenApi - ', isOpenApi());
  console.log('debug: API_URL - ', API_URL);
  console.log(
    'debug: process.env.GATSBY_OPEN_API_URL - ',
    process.env.GATSBY_OPEN_API_URL
  );
  if (isOpenApi()) {
    removeAuth();
    const url = `${API_URL}/v1/auth/lineUserIDAuth`;
    return request(url, {
      method: 'POST',
      headers: {
        'x-liff-id': liffId,
        'x-lineuser-id': userId,
        ...(service && { 'x-requested-service': service }),
      },
    }).then((res) => res.accessToken);
  } else {
    return request(`${API_URL}/api/token`, {
      method: 'GET',
      headers: {
        'X-liff-Id': liffId,
        'x-lineuser-id': userId,
        ...(service && { 'x-requested-service': service }),
      },
      withAuth: false,
    }).then((res) => {
      return res.token;
    });
  }
};

export const fetchOpenApiAuthToken = async ({ liffId, userId }) => {
  const url = `${process.env.GATSBY_OPEN_API_URL}/v1/auth/lineUserIDAuth`;
  return request(url, {
    method: 'POST',
    headers: {
      'x-liff-id': liffId,
      'x-lineuser-id': userId,
    },
  }).then((res) => res.accessToken);
};

export const reFetchAuthToken = async () => {
  const {
    'x-liff-id': liffId,
    'x-lineuser-id': userId,
    'x-requested-service': service = '',
  } = getAuth();
  const newToken = await fetchAndSaveAuthToken({ liffId, userId, service });
  setAuth({ token: newToken, liffId, userId, service });
  return new Promise((resolve) => resolve(newToken));
};

export const getUserInfo = () => {
  const url = isOpenApi()
    ? `${API_URL}/api/internal/user`
    : `${API_URL}/api/user`;

  return request(url, {
    method: 'GET',
  });
};

export const getPasscode = ({ phone }) => {
  const url = isOpenApi()
    ? `${API_URL}/api/internal/phone/passcode`
    : `${API_URL}/api/phone/passcode`;
  return request(url, {
    method: 'POST',
    payload: { phone },
  });
};

export const validatePasscode = ({
  phone: rawPhone,
  passcode,
  lineVerify = false,
  email,
  lineProfileName,
}) => {
  const url = isOpenApi()
    ? `${API_URL}/api/internal/phone/valid`
    : `${API_URL}/api/phone/valid`;
  const phone = rawPhone.replace(/\+886/g, '0');

  return request(url, {
    method: 'POST',
    payload: {
      phone,
      passcode,
      lineVerify,
      email,
      lineProfileName,
    },
  });
};

export const createSelf = ({
  name,
  idNum,
  birth,
  idType,
  gender,
  email,
  address,
  customerSource,
}) => {
  const url = isOpenApi()
    ? `${API_URL}/api/internal/self`
    : `${API_URL}/api/self`;

  const payload = {
    name,
    idType,
    gender,
    IdNum: idNum,
    Birth: birth,
    customerSource,
  };

  if (email) {
    payload.email = email;
  }
  if (address) {
    payload.address = address;
  }
  console.log('payload', payload);

  return request(url, {
    method: 'POST',
    payload,
  });
};

export const updatePatient = ({
  id,
  name,
  birth,
  idNum,
  idType,
  gender,
  note,
  relation: alias,
  email,
  address,
}) => {
  const url = isOpenApi()
    ? `${API_URL}/api/internal/patient/${id}`
    : `${API_URL}/api/patient/${id}`;

  const payload = { name, birth, idType, gender };
  if (alias) {
    payload.alias = alias;
  }
  if (idNum) {
    payload.idNum = idNum;
  }
  if (note) {
    payload.note = note;
  }
  if (email) {
    payload.email = email;
  }
  if (address) {
    payload.address = address;
  }
  return request(url, {
    method: 'PUT',
    payload,
  });
};

export const listMembers = async () => {
  try {
    const user = await getUserInfo();
    return {
      bindingPhoneNumber: user.Phone,
      members: user.patients
        ? user.patients
            .filter((p) => !p.isSelf)
            .map((p) => {
              const { id, name, idNum, birth, alias: relation } = p;
              return {
                ...p,
                id: `${id}`,
                name,
                idNum,
                birth,
                relation,
                customerSource: user.customerSource || '',
              };
            })
        : [],
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createMember = ({
  name,
  relation,
  idNum,
  idType,
  gender,
  birth,
  email,
  address,
  customerSource,
}) => {
  const url = isOpenApi()
    ? `${API_URL}/api/internal/patient`
    : `${API_URL}/api/patient`;

  const payload = {
    name,
    idType,
    IdNum: idNum,
    Birth: birth,
    alias: relation,
    gender,
  };

  if (email) {
    payload.email = email;
  }
  if (address) {
    payload.address = address;
  }
  if (customerSource) {
    payload.customerSource = customerSource;
  }

  return request(url, {
    method: 'POST',
    payload,
  });
};

export const deleteMember = ({ id }) => {
  const url = isOpenApi()
    ? `${API_URL}/api/internal/patient/${id}`
    : `${API_URL}/api/patient/${id}`;

  return request(url, {
    method: 'DELETE',
  });
};
